import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

function EtsyIcon({ size = 20, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
    >
      <path d="M9.16 4.945c0-.324.108-.432.54-.432h5.076c1.188 0 1.62.216 1.836 1.296l.324 1.512h.54l-.108-3.996h-.54c-.216.54-.432.756-1.08.756H9.7c-.432 0-.54-.108-.54-.432V.777L8.188.993v2.664H5.308v.54h2.88v8.964c0 .324-.108.432-.54.432H5.308v.54h7.776c3.996 0 6.876-2.016 6.876-4.392 0-2.052-1.944-3.564-4.752-3.996 2.16-.648 3.456-2.052 3.456-3.78 0-1.512-1.188-2.664-3.78-2.664H5.308v.54h2.34c.432 0 .54.108.54.432v5.076h.972V4.945z" />
    </svg>
  );
}

export function Footer() {
  return (
    <footer className="bg-[var(--color-bg-card)] border-t border-[var(--color-border)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="inline-block">
              <img
                src="/static/images/branding/logo anterior.png"
                alt="StudioComm"
                className="h-24 w-auto"
              />
            </Link>
            <p className="mt-4 text-[var(--color-text-muted)] text-sm max-w-md">
              Every line, drawn by hand.
              Art commissions since 2020.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-sm font-semibold text-[var(--color-text)] mb-4">
              Platform
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="link-underline focus-ring text-sm text-[var(--color-text-muted)] hover:text-[var(--color-text)] transition-colors duration-200"
                >
                  Browse Artists
                </Link>
              </li>
              <li>
                <Link
                  to="/how-it-works"
                  className="link-underline focus-ring text-sm text-[var(--color-text-muted)] hover:text-[var(--color-text)] transition-colors duration-200"
                >
                  How It Works
                </Link>
              </li>
              <li>
                <Link
                  to="/commission"
                  className="link-underline focus-ring text-sm text-[var(--color-text-muted)] hover:text-[var(--color-text)] transition-colors duration-200"
                >
                  Start a Commission
                </Link>
              </li>
              <li>
                <a
                  href="/dashboard/"
                  className="link-underline focus-ring text-sm text-[var(--color-text-muted)] hover:text-[var(--color-text)] transition-colors duration-200"
                >
                  Artist Login
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="text-sm font-semibold text-[var(--color-text)] mb-4">
              Connect
            </h3>
            <div className="flex gap-4">
              <a
                href="https://www.etsy.com/shop/studiocomm/"
                target="_blank"
                rel="noopener noreferrer"
                className="pressable focus-ring inline-flex rounded-full p-1 -m-1 text-[var(--color-text-muted)] hover:text-[var(--color-primary)] hover:-translate-y-0.5"
                aria-label="Etsy Shop"
              >
                <EtsyIcon size={20} />
              </a>
              <a
                href="mailto:studio.comm@outlook.com"
                className="pressable focus-ring inline-flex rounded-full p-1 -m-1 text-[var(--color-text-muted)] hover:text-[var(--color-primary)] hover:-translate-y-0.5"
                aria-label="Email"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-[var(--color-border)]">
          <p className="text-center text-sm text-[var(--color-text-muted)]">
            &copy; 2020-{new Date().getFullYear()} StudioComm. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
